<template>
  <a-button
    class="message-content"
    type="link"
    style="color: rgba(0, 0, 0, 0.65)"
    :class="prefixCls"
    @click="$router.push({ name: 'messageCenter' })"
  >
    <a-badge :count="allCount">
      <a-icon type="bell" style="font-size: 20px; color: #595959" />
    </a-badge>
    <!-- <div class="message-tip" v-if="allCount && showMessagePop">
      <div class="message-title">{{ messageTitle }}</div>
      <div style="display: flex; " :style="{ justifyContent: messageId ? 'space-between' : 'flex-end' }">
        <a v-if="messageId" style="cursor: pointer" @click="handleInfoRead([messageId])">标记已读</a>
        <span
          @click="
            $router.push({
              name: 'messageCenter',
              query: { type: 'noView' },
            })
          "
          style="cursor: pointer"
          >前往查看</span
        >
      </div>
    </div> -->
    <!-- <a-dropdown placement="bottomCenter" >
      <a-badge :count="allCount">
        <a-icon type="bell" style="font-size: 20px; " />
      </a-badge>
       <template #overlay>
        <a-menu>
          <a-menu-item
            style="display: flex"
            v-for="item in messageCenterData"
            :key="item.key"
            @click="goMessageCenterPage(item)"
          >
            <a href="javascript:;">{{ item.title }}</a>
            <a-badge style="margin-left: 20px" :count="allCount" />
          </a-menu-item>
          <a-menu-item>
            <span @click="$router.push({ name: 'messageCenter' })" style="cursor: pointer; color: #1890ff"
              >前往查看</span
            >
          </a-menu-item>
        </a-menu>
      </template> 
    </a-dropdown> -->
  </a-button>
</template>
<script>
export default {
  name: 'MessageCenter',
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    messageTitle: {
      type: String,
      default: '',
    },
    messageId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      messageVisible: true,
    }
  },
  created() {
    this.getMessageCenterData()
  },
  computed: {
    allCount() {
      return this.$store.state.messageCenter.allCount
    },
    messageCenterData() {
      return this.$store.state.messageCenter.messageCenterData
    },
    showMessagePop() {
      return this.$store.state.messageCenter.showMessagePop
    },
  },
  methods: {
    goMessageCenterPage(item) {
      this.$store.commit('CHANGE_MESSAGETYPE', item.messageType)
      this.$router.push({
        name: 'messageCenter',
        query: { id: this.messageId },
      })
    },
    getMessageCenterData() {
      this.$store.dispatch('getMessageCenterData')
    },
    handleAllRead() {
      this.$store.dispatch('handleAllRead').then((res) => {
        if (res.code == '1') {
          this.$store.commit('SET_ALL_COUNT', 0)
          return this.$message.success('已全部设为已读')
        }
      })
    },
    handleInfoRead(id) {
      this.$store.dispatch('handleInfoRead', id).then((res) => {
        if (res.code == '1') {
          this.$store.commit('CHANGE_SHOW_MESSAGEPOP', false)
          return this.$message.success('已设为已读')
        }
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
<style lang="less">
.message-content {
  position: relative;
  padding: 4px 12px 0;
  .message-tip {
    position: absolute;
    transform: translateX(-50%);
    padding: 10px;
    width: 200px;
    line-height: 30px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    .message-title {
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
    }
  }
}
</style>
